<template>
  <!--10kV配电系统图一-->
  <div class="jsOnceImg1">
    <div class="onceImgBgc">
      <div class="bgcImg">
        <img alt="" class="bgc"
             src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/onceImg/jinshui/onceImg1.png">
        <div class="tableItem tableItem1">
          <p>UAB (V) : {{ data.ah1.ua }}</p>
          <p>UBC (V) : {{ data.ah1.ub }}</p>
          <p>UCA (V) : {{ data.ah1.uc }}</p>
          <p>Ia (A) : {{ data.ah1.la }}</p>
          <p>Ib (A) : {{ data.ah1.lb }}</p>
          <p>Ic (A) : {{ data.ah1.lc }}</p>
          <p>P (kw) : {{ data.ah1.p }}</p>
        </div>
        <div class="tableItem tableItem2">
          <p>UAB (V) : {{ data.ah2.ua }}</p>
          <p>UBC (V) : {{ data.ah2.ub }}</p>
          <p>UCA (V) : {{ data.ah2.uc }}</p>
          <p>Ia (A) : {{ data.ah2.la }}</p>
          <p>Ib (A) : {{ data.ah2.lb }}</p>
          <p>Ic (A) : {{ data.ah2.lc }}</p>
          <p>P (kw) : {{ data.ah2.p }}</p>
        </div>
        <div class="tableItem tableItem3">
          <p>UAB (V) : {{ data.ah4.ua }}</p>
          <p>UBC (V) : {{ data.ah4.ub }}</p>
          <p>UCA (V) : {{ data.ah4.uc }}</p>
          <p>Ia (A) : {{ data.ah4.la }}</p>
          <p>Ib (A) : {{ data.ah4.lb }}</p>
          <p>Ic (A) : {{ data.ah4.lc }}</p>
          <p>P (kw) : {{ data.ah4.p }}</p>
        </div>
        <div class="tableItem tableItem4">
          <p>UAB (V) : {{ data.ah3.ua }}</p>
          <p>UBC (V) : {{ data.ah3.ub }}</p>
          <p>UCA (V) : {{ data.ah3.uc }}</p>
          <p>Ia (A) : {{ data.ah3.la }}</p>
          <p>Ib (A) : {{ data.ah3.lb }}</p>
          <p>Ic (A) : {{ data.ah3.lc }}</p>
          <p>P (kw) : {{ data.ah3.p }}</p>
        </div>

        <div class="imgBox">
          <div class="imgItem">
            <img v-show="data.ah1.status!=='合'" alt=""
                 src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/onceImg/jinshui/open.png">
            <img v-show="data.ah1.status==='合'" alt=""
                 src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/onceImg/jinshui/close.png">
          </div>
          <div class="imgItem">
            <img v-show="data.ah2.status!=='合'" alt=""
                 src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/onceImg/jinshui/open.png">
            <img v-show="data.ah2.status==='合'" alt=""
                 src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/onceImg/jinshui/close.png">
          </div>
          <div class="imgItem">
            <img v-show="data.ah4.status!=='合'" alt=""
                 src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/onceImg/jinshui/open.png">
            <img v-show="data.ah4.status==='合'" alt=""
                 src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/onceImg/jinshui/close.png">
          </div>
          <div class="imgItem">
            <img v-show="data.ah3.status!=='合'" alt=""
                 src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/onceImg/jinshui/open.png">
            <img v-show="data.ah3.status==='合'" alt=""
                 src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/onceImg/jinshui/close.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import {nextTick, onMounted, ref} from "vue";
import {getJinshuiOnePicDataApi} from "@/api/modules/onceImg";
import {ElMessage} from "element-plus";

// 一次图数据
let data = ref({
  ah1: {
    la: "",
    lb: "",
    lc: "",
    p: "",
    status: "",
    ua: "",
    ub: "",
    uc: "",
  },
  ah2: {
    la: "",
    lb: "",
    lc: "",
    p: "",
    status: "",
    ua: "",
    ub: "",
    uc: "",
  },
  ah3: {
    la: "",
    lb: "",
    lc: "",
    p: "",
    status: "",
    ua: "",
    ub: "",
    uc: "",
  },
  ah4: {
    la: "",
    lb: "",
    lc: "",
    p: "",
    status: "",
    ua: "",
    ub: "",
    uc: "",
  },
})

const resizeFun = function () {
  nextTick(() => {
    let ele = document.querySelector('.onceImgBgc')
    let scaleX = (ele.clientWidth) / 840
    let scaleY = (ele.clientHeight) / 630
    // document.querySelector('.bgcImg').style.transform = `scale(${scaleX},${scaleY})`
    for (let i = 0; i < document.querySelectorAll('.bgcImg').length; i++) {
      document.querySelectorAll('.onceImgBgc .bgcImg')[i].style.transform = `scale(${scaleX},${scaleY})`
    }
  })
}
onMounted(() => {
  nextTick(() => {
    resizeFun()
  })
  window.onresize = () => {
    resizeFun()
  }

  getJinshuiOnePicDataApi().then(res => {
    if (res.data.code === 0) {
      data.value = res.data.result
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
})
</script>

<style lang="less" scoped>
.jsOnceImg1, .jsOnceImg1 .onceImgBgc {
  width: 100%;
  height: 100% !important;

  .bgcImg {
    width: 840px;
    height: 630px;
    transform-origin: 0% 0%;
    position: relative;

    .bgc {
      width: 100%;
      height: 100%;
    }

    .imgBox {
      .imgItem {
        width: 22px;
        height: 34px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .imgItem:nth-child(1) {
        position: absolute;
        top: 216px;
        left: 132px;
      }

      .imgItem:nth-child(2) {
        position: absolute;
        top: 167px;
        left: 309px;
      }

      .imgItem:nth-child(3) {
        position: absolute;
        top: 167px;
        left: 486px;
      }

      .imgItem:nth-child(4) {
        position: absolute;
        top: 167px;
        left: 663px;
      }
    }

    .tableItem {
      font-size: 8px;
      display: none;

      p {
        color: #EAFA42;
        font-size: 8px;
        margin-bottom: 2px;
        transform: scale(0.8);
      }

      p:nth-child(2n) {
        color: #2EEF28;
      }

      p:nth-child(3n) {
        color: #FF0000;
      }

      p:nth-child(7) {
        color: #00F6F4;
      }
    }

    .tableItem1 {
      display: block;
      position: absolute;
      top: 432px;
      left: 121px;
    }

    .tableItem2 {
      display: block;
      position: absolute;
      top: 432px;
      left: 294px;
    }

    .tableItem3 {
      display: block;
      position: absolute;
      top: 432px;
      left: 470px;
    }

    .tableItem4 {
      display: block;
      position: absolute;
      top: 432px;
      left: 650px;
    }

    .tableItem5 {
      display: block;
      position: absolute;
      top: 432px;
      left: 320px;
    }

    .tableItem6 {
      display: block;
      position: absolute;
      top: 432px;
      left: 383px;
    }

    .tableItem7 {
      display: block;
      position: absolute;
      top: 432px;
      left: 445px;
    }

    .tableItem8 {
      display: block;
      position: absolute;
      top: 432px;
      left: 510px;
    }

    .tableItem9 {
      display: block;
      position: absolute;
      top: 432px;
      left: 575px;
    }

    .tableItem10 {
      display: block;
      position: absolute;
      top: 432px;
      left: 635px;
    }

    .tableItem11 {
      display: block;
      position: absolute;
      top: 432px;
      left: 700px;
    }

    .tableItem12 {
      display: block;
      position: absolute;
      top: 432px;
      left: 780px;
    }


    .dataItemList {
      font-size: 8px;
      display: none;

      p {
        font-size: 8px;
        margin-bottom: 0 !important;
        transform: scale(0.7);
        transform-origin: 0% 0%;
        //display: inline-block;
        white-space: nowrap;
        width: 44px;
      }

      p:nth-of-type(1) {
        color: #EAFA42 !important;
      }

      p:nth-of-type(2) {
        color: #2EEF28 !important;
      }

      p:nth-of-type(3) {
        color: #FF0000 !important;
      }

      p:nth-of-type(4) {
        color: #00F6F4 !important;
      }

      p:nth-of-type(3), p:nth-of-type(4) {
        transform: scale(0.7) translateY(-7px) !important;
      }
    }

    .dataItemList1 {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
    }

    .dataItemList2 {
      display: block;
      position: absolute;
      top: 74px;
      left: 0;
    }

    .dataItemList3 {
      display: block;
      position: absolute;
      top: 148px;
      left: 0;
    }

    .dataItemList4 {
      display: block;
      position: absolute;
      top: 222px;
      left: 0;
    }
  }
}
</style>
